import req from './req'

export function sp_save_upv (params) {
  return req.post('/it/save_upv', params)
}
const trackerAPI = {
  sp_save_upv
}
export default trackerAPI
